export const COORDS_CLOSE_EPSILON = 0.000025;

export const ADD_BUILDING_STEP_PARAM = "step";

export const STEP = {
  address: 0,
  buildingDetails: 4,
  fileUpload: 5,
  final: 6,
  layers: 3,
  outline: 2,
  summary: 1,
} as const;
export type StepKey = keyof typeof STEP;
export type StepNo = (typeof STEP)[StepKey];
export const STEP_ORDER: StepKey[] = Object.entries(STEP)
  .sort((a, b) => a[1] - b[1])
  .map(([key]) => key as StepKey);

export const LAST_FORM_STEP_NO = STEP.final - 1;

export const URL_STEP_MIN = 1;
export const URL_STEP_MAX = Math.max(...Object.values(STEP)) + 1;
